import React from 'react'

const Search = (props) => {
 
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.6666 11.6667L13.75 13.7501" stroke={props.color ? props.color : "#202327"} strokeOpacity="0.6" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M13.6944 15.4376C13.213 14.9561 13.213 14.1756 13.6944 13.6943C14.1758 13.2129 14.9563 13.2129 15.4377 13.6943L17.9723 16.2289C18.4537 16.7103 18.4537 17.4908 17.9723 17.9721C17.4909 18.4536 16.7104 18.4536 16.229 17.9721L13.6944 15.4376Z" stroke={props.color ? props.color : "#202327"} strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M13.3333 7.50008C13.3333 4.27842 10.7216 1.66675 7.49996 1.66675C4.2783 1.66675 1.66663 4.27842 1.66663 7.50008C1.66663 10.7217 4.2783 13.3334 7.49996 13.3334C10.7216 13.3334 13.3333 10.7217 13.3333 7.50008Z" stroke={props.color ? props.color : "#202327"} strokeOpacity="0.6" strokeWidth="1.5" strokeLinejoin="round"/>
</svg>

  )
}

export default Search
